var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAIconCopyActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9992 1.00042H3.99916C2.90021 1.00042 1.99958 1.90105 1.99958 3V17.0008H3.99916V3H15.9992V1.00042Z",
    fill: "#2E7D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8282 6.192L18.9992 8.06526V7.00042H7.99958V21H18.9992V13.2606L21 11.3634V21.0013C21 22.1002 20.0994 23.0008 18.9992 23.0008H7.99958C6.90063 23.0008 6 22.1002 6 21V7.00042C6 5.90147 6.89937 5.00084 7.99958 5.00084H18.9992C19.8126 5.00084 20.5162 5.49221 20.8282 6.19326V6.192Z",
    fill: "#2E7D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4211 15.2918L10.1293 12L9.00758 13.1128L13.4211 17.5263L22.8947 8.05263L21.7819 6.93979L13.4211 15.2918Z",
    fill: "#2E7D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAIconCopyActive);
export default __webpack_public_path__ + "static/media/a_icon_copy_active.544da766.svg";
export { ForwardRef as ReactComponent };